import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';
import { updateLoadingMessage, updateLoadingTitle } from '../slices/loadingSlice';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: baseQuery,
  tagTypes: ['productData', 'productCredentialDetail', 'productList'],
  endpoints: (builder) => ({
    getProductConfigDetails: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'getProductConfigDetails'
        );
      },
      providesTags: ['productCredentialDetail'],
    }),

    getProductData: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getProductData');
      },
      providesTags: ['productData'],
    }),

    getProductListData: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'getProductListData'
        );
      },
      providesTags: ['productList'],
    }),

    addNewProduct: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'addNewProduct');
      },
      invalidatesTags: ['productList'],
    }),

    updateProductData: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'updateProductData'
        );
      },
      invalidatesTags: ['productData'],
    }),

    updateCredentialData: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'updateCredentialData'
        );
      },
      invalidatesTags: ['productCredentialDetail'],
    }),

    getTransactionList: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'getTransactionList'
        );
      },
    }),

    getFiservDID: builder.mutation({
      query: (payload) => ({
        url: '/fiserv_did_request',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        dispatch(updateLoadingTitle('Generating Datawire ID (DID)...'))
        dispatch(updateLoadingMessage('Please wait. Do not close your browser.'))
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getFiservDID');
      },
    }),
  }),
});

export const {
  useLazyGetProductConfigDetailsQuery,
  useGetProductConfigDetailsQuery,
  useLazyGetProductDataQuery,
  useGetProductListDataQuery,
  useLazyGetProductListDataQuery,
  useGetProductDataQuery,
  useAddNewProductMutation,
  useLazyGetTransactionListQuery,
  useUpdateProductDataMutation,
  useUpdateCredentialDataMutation,
  useGetFiservDIDMutation,
} = productApi;
